<template>
  <div :id="id" :class="className" style="width:100%; max-width: 100vw;"></div>
</template>

<script>
import EventBus from '@/plugins/event-bus/events';

export default {
  name: 'BackboneContainer',
  props: {
    id: String,
    className: String,
    dispatchReadyOnMount: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    // console.log('BackboneContainer.mounted');
    // console.log('dispatchReadyOnMount=', this.dispatchReadyOnMount);
    if (this.dispatchReadyOnMount) {
      const dispatch = () => {
        // console.log('[VUE] dispatching event session:fetch');

        let evtData;
        if (['session.status.success', 'session.status.checked'].includes(this.$store.state.session.status)) {
          // eslint-disable-next-line no-underscore-dangle
          evtData = this.$store.state.session.session.__$backbone_restaccess_response__;
          console.log('session:fetch evtData from BACKBONE_CONTAINER', evtData);
        }

        EventBus.dispatchEvent('session:fetch', evtData);
      };
      EventBus.once('request:session', () => {
        // console.log('[VUE] received event request:session');
        dispatch();
      });
      dispatch();
    }
  },
};
</script>
